import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class ReceiptProdDetailService extends DatabaseGwService{

  URL_PATH: string = "/receipt-prod-details";
}
